module.exports = __webpack_public_path__ + "img/file-plus-minus.99ba2756.svg";